//接口
//引入axios
import request from '../utils/request'; // 这里是引入咱们的axios用axios来进行异步接口请求

//比如说接口为注册接口
export function pageArticleByModuleId(data) {
  return request({
    url: '/index/pageArticleByModuleId',
    method: 'post',
    data, // 一般post请求，我们习惯使用 data属性来传参
  });
}

export function listBannerByModuleId(data) {
  return request({
    url: '/index/listBannerByModuleId',
    method: 'post',
    data, //一般get请求，我们习惯使用params属性来传参
  });
}

// 儿童画廊
export function listKids(data) {
  return request({
    url: '/index/listKids',
    method: 'post',
    data, //一般get请求，我们习惯使用params属性来传参
  });
}

export function getArticleById(data) {
  return request({
    url: '/index/getArticleById',
    method: 'post',
    data, //一般get请求，我们习惯使用params属性来传参
  });
}


export function listAddress() {
  return request({
    url: '/index/listAddress',
    method: 'post'
  });
}


export function listInfo(data) {
  return request({
    url: '/index/listInfo',
    method: 'post',
	data,
  });
}

export function getRemembering(data) {
  return request({
    url: '/index/getRemembering',
    method: 'post',
	data,
  });
}

export function pageInfo(data) {
  return request({
    url: '/index/pageInfo',
    method: 'post',
	data,
  });
}


export function listSpecFund(data) {
  return request({
    url: '/index/listSpecFund',
    method: 'post',
	data,
  });
}


export function getSpecFund(data) {
  return request({
    url: '/index/getSpecFund',
    method: 'post',
	data,
  });
}

export function getFundProjectInfo(data) {
  return request({
    url: '/index/getFundProjectInfo',
    method: 'post',
	data,
  });
}

export function getSpecFundInfo(data) {
  return request({
    url: '/index/getSpecFundInfo',
    method: 'post',
	data,
  });
}


export function pageKids(data) {
  return request({
    url: '/index/pageKids',
    method: 'post',
	data,
  });
}

export function getUpPage(data) {
  return request({
    url: '/index/getUpPage',
    method: 'post',
	data,
  });
}
